import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';

import { IFormState, TElement } from '../types/calculator';
import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { useCalculatorCustomEvents } from './useCalculatorCustomEvents';
import { selectDefaultFormState } from '../selectors';
import { useEffect } from 'react';
import { useApplicationContext } from 'shared/common/utils/applicationContext';
import { ERuntimeSettings } from 'shared/common/types/runtimeSettings';

export const useCalculatorForm = (formScheme: TElement[], formRef: HTMLFormElement | null) => {
  const preselectedFormValues = useSelector(selectDefaultFormState);
  const { config } = useApplicationContext();
  const isLifeInsuranceFieldEnabled = config.get<boolean>(ERuntimeSettings.lifeInsuranceFieldEnabled) ?? false;

  const reactHookForm = useForm<IFormState>({
    mode: 'onChange',
  });

  const { formState, getValues, reset } = reactHookForm;
  const formValues = getValues();

  // установка дефолтных значение при инициализации
  useEffect(() => {
    reset({
      ...DEFAULT_FORM_STATE,
      ...preselectedFormValues,
      ...(!isLifeInsuranceFieldEnabled && { lifeInsurance: undefined }),
    });
  }, [isLifeInsuranceFieldEnabled, preselectedFormValues, reset]);

  // TODO: данный хук добавляет дополнительные рендеры, нужно оптимизировать
  useCalculatorCustomEvents({ formValues, formState, eventTarget: formRef, formScheme });

  return { reactHookForm };
};
